<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="article-books">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="far fa-sticky-note"></i>
                        小説へ公開
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="text-muted small mb-3">
                        小説へ記事を公開します。
                        公開記事は目次ページ、目次サイドバーに表示されます。
                    </div>
                    <div v-for="b in books.all" :key="b.id"
                        class="selector"
                        :class="{active: isSelected(b)}"
                        @click="toggleBooks(b)">
                        <i class="far fa-check-square" v-if="isSelected(b)"></i>
                        <i class="far fa-square" v-else></i>
                        {{b.title}}
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button class="btn btn-outline-danger" type="button" @click="commit()">
                        <i class="fas fa-check"></i>
                        確定
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.selector {
    border: 1px solid #ddd;
    padding: .7rem;
    margin-bottom: .5rem;
    border-radius: .5rem;
    cursor: pointer;
}
</style>

<script>
export default {
    props: {
        article: {
            default: null
        }
    },
    data() {
        return {
            books: [],
            selected: [],
        }
    },
    methods: {
        load() {
            axios.get("/mypage/books/get?all=1").then(res => {
                res.data.all = _.orderBy(res.data.writing.concat(res.data.finished).concat(res.data.pending), ["order_number"]);
                this.books = res.data;
                this.selected = [];
                if (this.article.books && this.article.books.length) {
                    for (const b of this.article.books) {
                        this.selected.push(b);
                    }
                }
            }).catch(err => { alert.err(err) });
        },
        commit() {
            this.$emit("commit", this.selected);
            $("#article-books").modal("hide");
        },
        toggleBooks(b) {
            const index = _.findIndex(this.selected, {id: b.id});
            if (index === -1) {
                this.selected.push(b);
            } else {
                this.selected.splice(index, 1);
            }
        },
        isSelected(b) {
            return _.find(this.selected, {id: b.id});
        }
    },
    mounted() {
        $("#article-books").on("show.bs.modal", () => {
            this.load();
        });
    }
}
</script>